import { lifecycle, compose } from "recompose";
import { withShop } from "web/core/shop/ShopContext";

let EcommerceImpressions = [],
  EcommerceDetail = undefined,
  EcommerceCheckout = undefined,
  EcommercePurchase = undefined;

const formatProductImpressions = (products, lastPosition, listType) =>
  products &&
  products.map((product, i) => {
    if (!product) {
      return {};
    }
    return {
      id: product.sku,
      name: product.name,
      price: product.prices.finalPrice.priceExclTax.value.amount,
      list: listType,
      category: product.product_range ?? "",
      position: parseInt(i) + parseInt(lastPosition) + 1,
    };
  });

const formatProductDetails = (product) => {
  const variantArray = product.sku.split(/[\s_]+/);
  const variant = variantArray.pop();

  return (
    product && [
      {
        id: product.sku,
        name: product.name,
        category: product.product_range ?? "",
        price: product.prices.finalPrice.priceExclTax.value.amount,
        variant: variant,
      },
    ]
  );
};

const formatProductPurchase = (purchase) =>
  purchase && {
    actionField: {
      id: purchase.order_id,
      revenue: purchase.totals.totalExclTax.value.amount,
      tax: purchase.totals.tax.value.amount,
      coupon: purchase.coupon_code,
    },
    products:
      purchase.items &&
      purchase.items.map((item) => {
        const variantArray = item.sku.split(/[\s_]+/);
        const variant = variantArray.pop();

        return {
          id: item.sku,
          name: item.name,
          price: Math.round(
            item.row_total.priceExclTax.value.amount / item.qty_ordered
          ),
          category: item.product.product_range ?? "",
          variant: variant,
          quantity: item.qty_ordered,
        };
      }),
  };

const formatProductCheckout = (currentStep, items) => {
  return (
    items && {
      actionField: {
        step: currentStep + 1,
      },
      products: items.map((item) => {
        const variantArray = item.sku.split(/[\s_]+/);
        const variant = variantArray.pop();

        return {
          id: item.sku,
          name: item.name,
          price: item.priceInfo.price.priceExclTax.value.amount,
          variant: variant,
          category: item.product.product_range ?? "",
          quantity: item.qty,
        };
      }),
    }
  );
};

const ecommerceDataLayer = (props) => {
  if (
    window.stopImmediateEcommerceDataLayer === true &&
    typeof EcommerceDetail === "undefined" &&
    typeof EcommerceCheckout === "undefined"
  ) {
    return;
  }

  if (typeof window.google_tag_manager === "undefined") {
    return;
  }

  if (
    window.google_tag_manager[process.env.FRONT_COMMERCE_WEB_GTM] === undefined
  ) {
    return;
  }

  if (
    window.google_tag_manager !== undefined &&
    window.google_tag_manager[process.env.FRONT_COMMERCE_WEB_GTM].dataLayer.get(
      "ecommerce"
    ) !== undefined
  ) {
    window.google_tag_manager[process.env.FRONT_COMMERCE_WEB_GTM].dataLayer.set(
      "ecommerce",
      undefined
    );
  }
  if (
    EcommerceImpressions.length > 0 &&
    typeof EcommerceDetail === "undefined" &&
    typeof EcommerceCheckout === "undefined"
  ) {
    window.dataLayer = window.dataLayer || [];

    if (props.category?.id && !props.customer?.id) {
      return;
    }

    window.dataLayer.push({
      event: "er_event_ecomm",
      ep: "ecommerce",
      ev: "impressions",
      ecommerce: {
        currencyCode: "EUR",
        impressions: EcommerceImpressions,
      },
    });
    window.stopImmediateEcommerceDataLayer = true;
  }
  if (EcommerceDetail !== undefined) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "er_page_view_asc",
      ecommerce: {
        currencyCode: "EUR",
        detail: EcommerceDetail,
      },
    });
  }

  if (EcommerceCheckout !== undefined) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "er_page_view_asc",
      ecommerce: {
        currencyCode: "EUR",
        checkout: EcommerceCheckout,
      },
    });
  }
  if (EcommercePurchase !== undefined) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "er_order_confirmation",
      ecommerce: {
        currencyCode: "EUR",
        checkout: EcommercePurchase,
      },
    });
  }
  EcommerceImpressions = [];
  EcommerceDetail = undefined;
  EcommerceCheckout = undefined;
  EcommercePurchase = undefined;
};
let ecommerceTimeout;
const withEcommerceDatalayer = compose(
  withShop(),
  lifecycle({
    componentDidMount: function () {
      clearTimeout(ecommerceTimeout);
      ecommerceTimeout = setTimeout(() => {
        ecommerceDataLayer(this.props);
      }, 3000);
    },
    componentDidUpdate: function () {
      clearTimeout(ecommerceTimeout);
      ecommerceTimeout = setTimeout(() => {
        ecommerceDataLayer(this.props);
      }, 3000);
    },
  })
);

const ecommerceProductImpressionDataLayer = (props) => {
  let listType = "";
  let products = [];

  if (typeof props.category !== "undefined") {
    listType = "category";
    products = props.products;
  } else if (typeof props.category === "undefined" && props.products) {
    listType = "search";
    products = props.products;
  } else if (
    typeof props.product !== "undefined" &&
    typeof props.data !== "undefined"
  ) {
    return;
  } else if (typeof props.data !== "undefined") {
    listType = "home";
    products = props.data.products;
  }

  let lastPosition = 0;

  if (props.location && typeof props.location !== "undefined") {
    const urlParams = new URLSearchParams(props.location.search);
    const pageNumber = urlParams.get("page");
    const numberOfItemsPerPage = 18;
    if (pageNumber && typeof pageNumber !== "undefined") {
      lastPosition = (pageNumber - 1) * numberOfItemsPerPage;
    }
  }

  products = formatProductImpressions(products, lastPosition, listType);
  if (!products) {
    return;
  }

  EcommerceImpressions = products.slice(0, 20);
};

const withEcommerceProductImpressions = compose(
  lifecycle({
    componentDidMount: function () {
      ecommerceProductImpressionDataLayer(this.props);
    },
    componentDidUpdate: function () {
      ecommerceProductImpressionDataLayer(this.props);
    },
  })
);

const withEcommerceProductDetails = compose(
  lifecycle({
    componentDidMount: function () {
      const product = formatProductDetails(this.props.product);
      if (!product) {
        return;
      }
      EcommerceDetail = { products: product };
    },
  })
);

const withEcommerceOrder = compose(
  lifecycle({
    componentDidMount: function () {
      if (!this.props.order) {
        return;
      }
      const purchase = formatProductPurchase(this.props.order);

      if (!purchase) {
        return;
      }
      EcommercePurchase = purchase;
    },
  })
);

const withEcommerceCheckout = compose(
  lifecycle({
    componentDidMount() {
      if (!this.props.cart) {
        return;
      }
      let step;
      if (this.props.basePath === "/cart") {
        step = 0;
      } else if (this.props.basePath === "/checkout/login") {
        step = 2;
      } else {
        step = this.props.currentStepNumber + 1;
      }
      const checkout = formatProductCheckout(step, this.props.cart.items);

      if (!checkout || step > 5) {
        return;
      }
      EcommerceCheckout = checkout;
    },
    componentDidUpdate(prevProps) {
      if (this.props.currentStepNumber !== prevProps.currentStepNumber) {
        if (!this.props.cart) {
          return;
        }
        const checkout = formatProductCheckout(
          this.props.currentStepNumber + 1,
          this.props.cart.items
        );

        if (!checkout || checkout.actionField.step > 5) {
          return;
        }
        window.dataLayer = window.dataLayer || [];

        window.dataLayer.push({
          event: "er_page_view_asc",
          ecommerce: {
            currencyCode: "EUR",
            checkout: checkout,
          },
        });
      }
    },
  })
);

export {
  withEcommerceDatalayer,
  withEcommerceProductImpressions,
  withEcommerceProductDetails,
  withEcommerceOrder,
  withEcommerceCheckout,
};
